import Button from 'ui/atoms/Button/Button';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import FormField from 'ui/molecules/FormField/FormField';
import Icon from 'ui/atoms/Icon/Icon';
import IconBubble from 'ui/molecules/IconBubble/IconBubble';
import TextArea from 'ui/atoms/TextArea/TextArea';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { useDialogFeedback } from './useDialogFeedback';

const DialogFeedBack = ({
  t,
  showAi,
  open,
  loadingGoodAI,
  loadingBadAI,
  onPositiveFeedback,
  onBadFeedback,
  feedback,
  onClose,
  onSuccess,
  generatedGoodFeedback,
  generatedBadFeedback,
}) => {
  const { showFeedbackGeneratedWithAI, goodFeedback, badFeedback, onChangeGoodFeedback, onChangeBadFeedback } = useDialogFeedback({
    feedback,
    generatedGoodFeedback,
    generatedBadFeedback,
  });

  return (
    <Dialog
      title={
        <div className="dialog-student-feedback__header-left">
          <Icon name="flag" color="primary" size="xl" /> <div className="dialog-student-feedback__header-title">{t('Feedback')}</div>
        </div>
      }
      isOpen={open}
      className={'dialog-feed-back'}
      buttonTextSuccess={t('actions:Save')}
      buttonTextCancel={t('actions:Cancel')}
      onCancel={onClose}
      onSuccess={() => onSuccess({ goodFeedback, badFeedback })}
      onClose={onClose}
      size="m"
      hasFooterBackground={true}
    >
      <div className="dialog-feed-back__container">
        <div className="dialog-feed-back__description">{t('assigments:Write briefly about the positive and best aspects of this task')}</div>
        <div className="dialog-feed-back__textarea-container dialog-feed-back__textarea-container--good">
          <div className="dialog-feed-back__textarea-header">
            <div className="dialog-feed-back__textarea-header-left">
              <IconBubble name="flame" background="green" />
              <span className="dialog-feed-back__textarea-title">{t('Things that are done very well')}</span>
            </div>
            <div className="dialog-feed-back__textarea-header-right">
              {showAi && showFeedbackGeneratedWithAI && (
                <Button ariaLabel={t('actions:Good feedback')} isIconOnly={true} leftIcon="ai" size="xs" text="AI" onClick={onPositiveFeedback} isLoading={loadingGoodAI} />
              )}
            </div>
          </div>
          <FormField isLabelHidden label={t('Things that are done very well')}>
            <TextArea placeholder={t('placeholder:Write here')} value={goodFeedback} onChange={({ target: { value } }) => onChangeGoodFeedback(value)} />
          </FormField>
        </div>
        <div className="dialog-feed-back__textarea-container dialog-feed-back__textarea-container--bad">
          <div className="dialog-feed-back__textarea-header">
            <div className="dialog-feed-back__textarea-header-left">
              <IconBubble name="thumbsup" background="orange" />
              <span className="dialog-feed-back__textarea-title">{t('Things that can be improved')}</span>
            </div>
            <div className="dialog-feed-back__textarea-header-right">
              {showAi && showFeedbackGeneratedWithAI && (
                <Button ariaLabel={t('actions:Bad feedback')} isIconOnly={true} leftIcon="ai" size="xs" text="AI" onClick={onBadFeedback} isLoading={loadingBadAI} />
              )}
            </div>
          </div>
          <FormField isLabelHidden label={t('Things that can be improved')}>
            <TextArea placeholder={t('placeholder:Write here')} value={badFeedback} onChange={({ target: { value } }) => onChangeBadFeedback(value)} />
          </FormField>
        </div>
      </div>
    </Dialog>
  );
};

DialogFeedBack.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  feedback: PropTypes.object,
};

DialogFeedBack.defaultProps = {
  onClose: function () {},
  open: false,
  feedback: {},
};

export default withTranslation(['assigments', 'actions'])(DialogFeedBack);
